import { ref } from 'vue';

/**
 * "On this page" table-of-contents bridge for the v3 homepage — the legacy
 * sibling of rm-portal-beta's `useHomeToc`. The landing renderer publishes one
 * entry per rendered widget; the contextual drawer consumes them for
 * jump-scroll. Module-scoped so the renderer and the drawer share one instance.
 *
 * Each entry: { id (DOM anchor of the widget wrapper), label, icon }.
 */
const entries = ref([]);

export function useHomeToc() {
  return {
    entries,
    setEntries: (next) => {
      entries.value = Array.isArray(next) ? next : [];
    },
    clear: () => {
      entries.value = [];
    },
  };
}
